import Productos from "ab-products";
import { useTranslation } from "next-i18next";
const ProductCategory = ({ categoria, classname, tag, i18n }) => {
  console.log("ProductCategory", categoria);
  let category = categoria?.[0];

  if (category?.products?.nodes?.length == 0) {
    return null;
  }
  const { t } = useTranslation("common", { i18n });
  return (
    <Productos
      className={classname}
      title={category?.name}
      description={category?.description}
      tag={tag}
      products={category?.products?.nodes?.map((itm) => ({
        src: itm?.image?.mediaItemUrl,
        name: itm.name,
        href: `${t("/tienda")}/${itm?.slug}`,
        price: itm.price,
        type: itm.type,
        attributes: itm?.attributes?.nodes,
        products: itm?.products?.nodes,
        slug: itm.slug,
        databaseId: itm.databaseId,
        location: category.name,
        stockStatus: itm?.stockStatus
      }))}
      link={
        classname == "hide-ver-todos"
          ? null
          : {
            text: t("todos"),
            href: `${t("/tienda/vinos-exclusivos")}/${category?.slug}`,
          }
      }
      i18n={i18n}
    />
  );
};

export default ProductCategory;
